<ng-container *ngIf="!noConsumptionData">
  <ng-container *ngIf="contract.HasContaCerta">
    <span class="card-title mb-3" *ngIf="isSameMonthRangeIRD"
      [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.titleHasContaCerta.sameMonthIRD'|
      translate:{
      'startDay': contract.Ird_start | date: 'dd',
      'endDay': contract.Ird_end | date: 'dd',
      'endMonth': contract.Ird_end | date: 'MMMM' | titlecase}">
    </span>
    <span class="card-title mb-3" *ngIf="!isSameMonthRangeIRD"
      [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.titleHasContaCerta'|
      translate:{
      'startDay': contract.Ird_start | date: 'dd',
      'startMonth': contract.Ird_start | date: 'MMMM':'pt | titlecase',
      'endDay': contract.Ird_end | date: 'dd',
      'endMonth': contract.Ird_end | date: 'MMMM' | titlecase}">
    </span>
  </ng-container>

  <ng-container *ngIf="!contract.HasContaCerta">
    <ng-container *ngIf="!activeMeters?.updateReadingInTime &&
      !activeMeters?.updateReadingOutTime">
      <span class="card-title mb-3" *ngIf="isSameMonthRangeIRD"
        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.title.sameMonthIRD'
        |
        translate:{
        'startDay': contract.Ird_start | date: 'dd',
        'endDay': contract.Ird_end | date: 'dd',
        'endMonth': contract.Ird_end | date: 'MMMM' | titlecase}">
      </span>
      <span class="card-title mb-3" *ngIf="!isSameMonthRangeIRD"
        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.title'
        |
        translate:{
        'startDay': contract.Ird_start | date: 'dd',
        'startMonth': contract.Ird_start | date: 'MMMM' | titlecase,
        'endDay': contract.Ird_end | date: 'dd',
        'endMonth': contract.Ird_end | date: 'MMMM' | titlecase}">
      </span>
    </ng-container>

    <ng-container *ngIf="activeMeters?.updateReadingInTime && !isMultiMeter">
      <span class="card-title mb-3" *ngIf="activeMeters?.simulation?.estimatedDays > 0; else invoiceForecast"
        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.inTime.update'
        |
        translate:{
        'amount': activeMeters?.simulation?.simulationValue | number:'.2',
        'days': activeMeters?.simulation?.estimatedDays }">
      </span>
    </ng-container>  

    <span class="card-title mb-3"
      *ngIf="activeMeters?.updateReadingInTime && isMultiMeter"
      [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.multi.inTime.update'
      |
      translate:{
      'amount': activeMeters?.simulation?.simulationValue | number:'.2',
      'days': activeMeters?.simulation?.estimatedDays }">
    </span>

    <ng-container *ngIf="activeMeters?.updateReadingOutTime">
      <span class="card-title mb-3"
        *ngIf="isSameMonthRangeIRD"
        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.outTime.update.sameMonthIRD'
        |
        translate:{ 
        'startDate': contract.Ird_start | date: 'dd',
        'endDay': contract.Ird_end | date: 'dd',
        'endMonth': contract.Ird_end | date: 'MMMM' | titlecase,
        'amount': activeMeters?.simulation?.simulationValue | number:'.2',
        'days': activeMeters?.simulation?.estimatedDays }">
      </span> 
      <span class="card-title mb-3"
        *ngIf="!isSameMonthRangeIRD"
        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.outTime.update.'
        |
        translate:{
        'startDate': contract.Ird_start | date: 'dd',
        'startMonth': contract.Ird_start | date: 'MMMM' | titlecase,
        'endDay': contract.Ird_end | date: 'dd',
        'endMonth': contract.Ird_end | date: 'MMMM' | titlecase,
        'amount': activeMeters?.simulation?.simulationValue  | number:'.2',
        'days': activeMeters?.simulation?.estimatedDays }">
      </span>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="noConsumptionData">
  <span class="card-title mb-3" 
  [innerHTML]="'pt.edponline.widget.consumptions.jumbotron.fill.fields.and.send.readings' | translate">
  </span> 
</ng-container>

<ng-container *ngIf="!noConsumptionData">
  <span class="card-subtitle" *ngIf="activeMeters?.lastInserted">
      {{ "pt.edp.edponline.dashboard.widget.consumptions.sent" | translate }}
      {{ activeMeters.lastInserted.date | date: "dd MMMM"  }}
      {{ "pt.edp.edponline.dashboard.widget.consumptions.by" | translate }}
      <span *ngIf=" activeMeters.lastInserted.mr_type === 'CLIENTE'"> {{ "pt.edp.edponline.readings.client"  | translate }}</span>
      <span *ngIf=" activeMeters.lastInserted.mr_type === 'EMPRESA'"> {{ "pt.edp.edponline.readings.business" | translate }}</span>
  </span>
</ng-container>

<ng-template #invoiceForecast>
  <span class="card-title mb-3"
    [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.invoice.forecast'
    |
    translate:{
    'amount': activeMeters?.simulation?.simulationValue | number:'.2' }">
  </span>
</ng-template>